<template>
  <div class="positive-circle" :style="sizeStyle">
      <icon name="plus" class='positive-circle__plus' :scale='scale'>
      </icon>
  </div>
</template>

<script>
import 'vue-awesome/icons/plus'
import Icon from 'vue-awesome/components/Icon'

const DEFAULT_SIZE = 25

export default {
  components: {
    Icon
  },
  props: {
    size: {
      type: Number,
      default: DEFAULT_SIZE
    }
  },
  computed: {
    sizeStyle () {
      return {
        'height': this.size + 'px',
        'width': this.size + 'px'
      }
    },
    scale () {
      return this.size / DEFAULT_SIZE
    }
  }
}
</script>

<style lang='scss'>
.positive-circle {
  background-color: green;
  border-radius: 50%;
  display: inline-block;
  text-align: center;

  &__plus {
    color: white;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// PositiveCircle.vue?bab90416